import React, { ReactElement, useEffect, useState, useCallback, useRef } from "react"
import { get, post } from "../../../netApi/fetch"

import { connect } from "react-redux"

import { setLoginBindInfo } from "../../../reducers"

import BanUnLogin from "../../../high-component/BanUnLogin"
import Main from "../../../high-component/Content"
import { useHistory } from "react-router"
import styled from "styled-components"
import { imageType } from "../../../methods/imageUpload"
import { message, Select, Modal, Spin, Segmented } from "antd"
import { PlayCircleOutlined, PauseCircleOutlined, RightOutlined } from "@ant-design/icons"
import { checkVideoQuota } from "../../../utils/quotaCheck"

// 定义类型
interface NoteType {
  id: string
  pid: string
  title: string
  content: string
  type: string
  image: string
  can_share: string
  show_read: string
  status: string
  createtime: string
  uid: string
  updatetime: string
  views: string
  comments: string
  reads: string
  sid: string
  images: imageType[]
  mp4?: {
    id: string
    url: string
    sound_url: string
    sound_id: string
    cover_url: string
    audio_status: string
    video_status: string
    cover_status: string
  }
  speech_recognition?: {
    id: string
    url: string
    text: string
  }
}

interface NoteComponentProps {
  note?: NoteType
  history: ReturnType<typeof useHistory>
  setLoginBindInfo?: (data: any) => void
  user?: any
  loginBindInfo?: any
}

const Title = styled.h1`
  font-size: 24px;
  margin-bottom: 10px;
  color: #333;
`

const CreationDate = styled.p`
  color: grey;
  font-size: 14px;
  margin-bottom: 15px;
`

const ImagesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  gap: 10px;
  margin-bottom: 20px;
`

const ImageUploadButton = styled.label`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 2px dashed #ddd;
  border-radius: 8px;
  height: 120px;
  width: 120px;
  cursor: pointer;
  transition: border-color 0.3s;

  &:hover {
    border-color: var(--theme-main);
  }

  input {
    display: none;
  }
`

const ImageItem = styled.div`
  position: relative;
  border-radius: 8px;
  overflow: hidden;

  img {
    width: 120px;
    height: 120px;
    object-fit: cover;
    display: block;
  }

  .delete-image,
  .edit-image {
    position: absolute;
    top: 5px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-weight: bold;
  }

  .delete-image {
    right: 5px;
  }

  .edit-image {
    right: 35px;
  }
`

const Content = styled.div`
  line-height: 1.6;
  margin-bottom: 20px;
  /* padding: 15px; */
  border-radius: 8px;
  /* border: 1px solid rgb(240, 240, 240); */
  min-height: 300px;
  font-size: 16px;
  line-height: 1.6;
  p {
    // 自然换行
    word-break: break-word;
    white-space: pre-wrap;
  }
`

const EditNoteButton = styled.button`
  background-color: #3498db;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #2980b9;
  }
`

const RightPanel = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
`

const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`

const LoadingSpinner = styled.div`
  width: 50px;
  height: 50px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid var(--theme-main, #3498db);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`

// 全局加载蒙版
const GlobalLoadingOverlay = styled.div`
  inset: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  backdrop-filter: blur(2px);
  border-radius: 12px;
`

const LoadingContent = styled.div`
  background: #fff;
  padding: 40px;
  border-radius: 16px;
  text-align: center;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  max-width: 400px;
  width: 90%;
`

const LoadingText = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 12px;
`

const LoadingSubText = styled.div`
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.5;
`

const EditButton = styled.button`
  background-color: #fff;
  color: var(--theme-main);
  border: none;
  padding: 10px 20px;
  border-radius: 50vmin;
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
  &.disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }
`

const EditButtonLignt = styled.button`
  background-color: var(--theme-main);
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 50vmin;
  font-size: 14px;
  cursor: pointer;
  font-weight: bold;
  &.disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
  }
`

const TabButton = styled.button<{ active: boolean; disabled?: boolean }>`
  flex: 1;
  padding: 8px 12px;
  border: none;
  background: ${(props) => (props.disabled ? "#f5f5f5" : props.active ? "var(--theme-main)" : "#fff")};
  color: ${(props) => (props.disabled ? "#ccc" : props.active ? "#fff" : "#666")};
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s;
  white-space: nowrap;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};

  &:hover {
    background: ${(props) => (props.disabled ? "#f5f5f5" : props.active ? "var(--theme-main)" : "#f5f5f5")};
  }
`

const GenerateButton = styled.button`
  width: 100%;
  padding: 12px 20px;
  background: var(--theme-main);
  color: #fff;
  border: none;
  border-radius: 50vmin;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: var(--theme-main-hover-light);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`

// ===== 新增的样式组件 =====
const ActionButton = styled.button`
  cursor: pointer;
  border-radius: 50vmin;
  background: var(--theme-main);
  color: #fff;
  padding: 8px 20px;
  font-size: 14px;
  border: none;
  font-weight: bold;
  &:hover {
    opacity: 0.8;
  }
`

const VideoList = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  margin-top: 12px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px;
  scroll-behavior: smooth;

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #aaa;
  }
`

const VideoItem = styled.div`
  position: relative;
  width: 150px;
  flex-shrink: 0;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition:
    transform 0.3s,
    box-shadow 0.3s;
  cursor: pointer;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  &.selected {
    border: 2px solid var(--theme-main);
  }
  &.selected::after {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 20px;
    z-index: 2;
    pointer-events: none;
  }
`

const LoadMoreButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 200px;
  flex-shrink: 0;
  border: 2px dashed #ddd;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s;
  background: #fafafa;

  &:hover {
    border-color: var(--theme-main);
    background: #f0f8ff;
    transform: translateY(-2px);
  }

  .load-more-icon {
    font-size: 24px;
    color: #666;
    transition: color 0.3s;
  }

  &:hover .load-more-icon {
    color: var(--theme-main);
  }
`

const VideoPlayer = styled.video`
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 12px;
  background: #000;
`

const VideoInfo = styled.div`
  padding: 12px;
  background: #fff;
`

const VideoTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const VideoTime = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
`

const SoundList = styled.div`
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding: 12px 0;
  max-height: 140px;

  &::-webkit-scrollbar {
    height: 8px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`

const SoundItem = styled.div`
  flex: 0 0 140px;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  background: #fff;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;

  &:hover {
    border-color: #d0d0d0;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &.selected {
    border-color: var(--theme-main);
    box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
  }
`

const SoundInfo = styled.div`
  padding: 6px 8px;
  background: #fff;
`

const SoundTitle = styled.div`
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

const SoundTime = styled.div`
  font-size: 12px;
  color: #999;
  margin-bottom: 8px;
`

const SoundLoadMoreButton = styled.div`
  flex: 0 0 80px;
  height: 100px;
  border: 2px dashed #d0d0d0;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #999;

  &:hover {
    border-color: var(--theme-main);
    color: var(--theme-main);

    .load-more-icon {
      transform: translateX(4px);
    }
  }

  .load-more-icon {
    font-size: 20px;
    transition: transform 0.3s ease;
  }
`

const ModalSection = styled.div`
  margin-bottom: 20px;
  text-align: left;
`

const GrayBox = styled.div`
  background: #f2f2f2;
  border-radius: 8px;
  padding: 16px;
  font-size: 14px;
  margin-top: 8px;
  max-width: 85%;
  min-width: 85%;
  float: left;
`

const AudioPlayerContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  background: #f5f5f5;
  border-radius: 12px;
  margin-top: 20px;

  audio {
    width: 100%;
    height: 40px;
    outline: none;

    &::-webkit-media-controls-panel {
      background-color: #f5f5f5;
    }
  }
`

const GlobalStyle = styled.div`
  .version-segmented {
    .ant-segmented-item {
      border-radius: 50vmin !important;
      color: var(--theme-main) !important;
      font-weight: bold;
    }
    .ant-segmented-item-selected {
      background-color: var(--theme-main) !important;
      color: #fff !important;
    }
    .ant-segmented-thumb {
      border-radius: 50vmin !important;
      background-color: var(--theme-main) !important;
      box-shadow: none !important;
    }
  }
`

const _defaultState: NoteType = {
  id: "10000",
  pid: "0",
  title: "",
  content: "",
  type: "1",
  image: "",
  can_share: "0", // 20250908 这俩保留字段暂时无用
  show_read: "0", // 20250908 这俩保留字段暂时无用
  status: "1",
  createtime: "2025-09-05 13:51:29",
  uid: "1000849186",
  updatetime: "2025-09-05 13:51:29",
  views: "0",
  comments: "0",
  reads: "0",
  sid: "1000849185",
  images: [],
}

const Note = (props): ReactElement => {
  console.log("Note props :>> ", props)
  const [isLogin, setIsLogin] = useState(props.user?.uid)
  const [noteData, setNoteData] = useState<NoteType>(_defaultState)
  const [images, setImages] = useState<imageType[]>(noteData.images)
  const [loading, setLoading] = useState(false)
  const [generatedVideo, setGeneratedVideo] = useState<string | null>(null)
  const urlSearchParams = new URLSearchParams(props.location.search)
  const autoFocus = urlSearchParams.get("auto_focus") || ""
  const pid = props.match.params.id // 现在是pid
  const history = props.history

  // 版本相关状态 - 从urls读取版本index
  const [versionList, setVersionList] = useState<NoteType[]>([])
  const [currentVersionIndex, setCurrentVersionIndex] = useState(() => {
    const versionFromUrl = urlSearchParams.get("version")
    return versionFromUrl ? parseInt(versionFromUrl) : -1 // -1表示还未加载
  })

  // 当前选中的生成类型：audio | video | cover | all
  const [activeTab, setActiveTab] = useState(() => {
    const tabFromUrl = urlSearchParams.get("tab")
    return tabFromUrl || "audio"
  })

  // 新增状态变量
  const [modalVisible, setModalVisible] = useState(false)
  const [generating, setGenerating] = useState(false)
  const [playbackRate, setPlaybackRate] = useState(1.5)
  const videoRef = React.useRef<HTMLVideoElement>(null)
  const pollingTimerRef = useRef<NodeJS.Timeout | null>(null)
  const isMounted = useRef(true)

  // 音频相关状态
  const [soundText, setSoundText] = useState("")
  const [soundUrl, setSoundUrl] = useState("")
  const [soundId, setSoundId] = useState(null)
  const [isPlaying, setIsPlaying] = useState(false)
  const audioRef = React.useRef<HTMLAudioElement | null>(null)
  const [soundList, setSoundList] = useState<any[]>([])
  const [soundOffsetIndex, setSoundOffsetIndex] = useState(0)
  const [soundLength, setSoundLength] = useState(0)
  const [selectedSoundId, setSelectedSoundId] = useState<string | number | null>(null)
  const [soundLoading, setSoundLoading] = useState(false)
  const soundLimit = 5

  // 视频模型相关状态
  const [contentList, setContentList] = useState<any[]>([])
  const [viewOffsetIndex, setViewOffsetIndex] = useState(0)
  const [viewLength, setViewLength] = useState(0)
  const [selectedVideoId, setSelectedVideoId] = useState<string | number | null>(null)
  const [innerLoading, setInnerLoading] = useState(false)
  const limit = 5

  // 生成的资源状态
  const [generatedAudioId, setGeneratedAudioId] = useState<string | null>(null)
  const [generatedAudioUrl, setGeneratedAudioUrl] = useState<string | null>(null)
  const [generatedCoverUrl, setGeneratedCoverUrl] = useState<string | null>(null)
  const generatedAudioRef = React.useRef<HTMLAudioElement>(null)

  // 清理定时器
  useEffect(() => {
    // 滚动到页面顶部
    window.scrollTo({ top: 0, behavior: "smooth" })
    return () => {
      isMounted.current = false
      if (pollingTimerRef.current) {
        clearInterval(pollingTimerRef.current)
      }
    }
  }, [])

  // 获取音频列表
  const handleGetSoundList = (reset = false) => {
    if (reset) setSoundLoading(true)
    const offset = reset ? 0 : soundOffsetIndex * soundLimit
    get(`/ip/viewmp3list?offset=${offset}&limit=${soundLimit}`, {})
      .then((res) => {
        console.log("ip/viewmp3list?offset :>> ", res)
        const soundArray = res.list || []

        if (reset) {
          setSoundList(soundArray)
          setSoundOffsetIndex(1)
          setSoundLength(res.count || 0)
        } else {
          setSoundList([...soundList, ...soundArray])
          setSoundOffsetIndex(soundOffsetIndex + 1)
          setSoundLength(res.count || 0)
        }

        if (soundArray.length > 0 && !selectedSoundId) {
          setSelectedSoundId(soundArray[0].id)
        }
        if (reset) setSoundLoading(false)
      })
      .catch((err) => {
        if (reset) setSoundLoading(false)
        console.error("获取音频列表失败:", err)
      })
  }

  // 获取视频模型列表
  const handleGetContentList = (reset = false) => {
    if (reset) setInnerLoading(true)
    const offset = reset ? 0 : viewOffsetIndex * limit
    get(`/ip/viewmp4list?offset=${offset}&limit=${limit}`, {})
      .then((res) => {
        setViewLength(res.count || 10)
        if (reset) {
          setContentList(res.list || [])
          setViewOffsetIndex(1)
        } else {
          setContentList([...contentList, ...(res.list || [])])
          setViewOffsetIndex(viewOffsetIndex + 1)
        }
        if (res.list.length > 0 && !selectedVideoId) {
          setSelectedVideoId(res.list[0].id)
        }
        if (reset) setInnerLoading(false)
      })
      .catch((err) => {
        if (reset) setInnerLoading(false)
        console.error("获取视频列表失败:", err)
      })
  }

  // 生成音频
  const handleGenerateAudio = () => {
    if (!selectedSoundId) {
      message.warning("请选择音频模型")
      return
    }
    setGenerating(true)
    setModalVisible(false)

    post("/ip/generateaudio", {
      contentId: noteData.id,
      soundId: selectedSoundId,
    })
      .then((res) => {
        setGenerating(false)
        message.success("AI音频生成成功！")

        if (res.contentId && res.pid !== noteData.pid) {
          // 保留当前URL参数并添加 contentId
          const currentParams = new URLSearchParams(props.location.search)
          currentParams.set('contentId', res.contentId)
          history.replace(`/index/content/${res.pid}?${currentParams.toString()}`)
          window.location.reload()
        } else if (res.contentId && res.contentId !== noteData.id) {
          // pid 相同但 contentId 不同，需要切换版本
          const currentParams = new URLSearchParams(props.location.search)
          currentParams.set('contentId', res.contentId)
          history.replace(`${props.location.pathname}?${currentParams.toString()}`)
        } else {
          setGeneratedAudioId(res.audioId)
          setGeneratedAudioUrl(res.audioUrl)
          setActiveTab("audio")
        }
      })
      .catch((err) => {
        setGenerating(false)
        if (!err) err = "生成失败"
        message.error(err.data || err.message || err)
      })
  }

  // 生成视频
  const handleGenerateVideo = async () => {
    if (!selectedVideoId) {
      message.warning("请选择视频模型")
      return
    }

    if (!generatedAudioUrl) {
      message.warning("请先生成音频")
      return
    }

    setGenerating(true)
    setModalVisible(false)

    post("/ip/generatevideo", {
      contentId: noteData.id,
      videoId: selectedVideoId,
      audioType: "generated",
    })
      .then((res) => {
        setGenerating(false)
        message.success("AI视频生成成功！")

        if (res.contentId && res.pid !== noteData.pid) {
          // 保留当前URL参数并添加 contentId
          const currentParams = new URLSearchParams(props.location.search)
          currentParams.set('contentId', res.contentId)
          history.replace(`/index/content/${res.pid}?${currentParams.toString()}`)
          window.location.reload()
        } else if (res.contentId && res.contentId !== noteData.id) {
          // pid 相同但 contentId 不同，需要切换版本
          const currentParams = new URLSearchParams(props.location.search)
          currentParams.set('contentId', res.contentId)
          history.replace(`${props.location.pathname}?${currentParams.toString()}`)
        } else {
          setGeneratedVideo(res.videoUrl)
          setActiveTab("video")
        }
      })
      .catch((err) => {
        setGenerating(false)
        if (!err) err = "生成失败"
        message.error(err.data || err.message || err)
      })
  }

  // 生成封面
  const handleGenerateCover = () => {
    setGenerating(true)

    post("/ip/generatecover", {
      contentId: noteData.id,
    })
      .then((res) => {
        setGenerating(false)
        message.success("封面生成成功！")

        if (res.contentId && res.pid !== noteData.pid) {
          // 保留当前URL参数并添加 contentId
          const currentParams = new URLSearchParams(props.location.search)
          currentParams.set('contentId', res.contentId)
          history.replace(`/index/content/${res.pid}?${currentParams.toString()}`)
          window.location.reload()
        } else if (res.contentId && res.contentId !== noteData.id) {
          // pid 相同但 contentId 不同，需要切换版本
          const currentParams = new URLSearchParams(props.location.search)
          currentParams.set('contentId', res.contentId)
          history.replace(`${props.location.pathname}?${currentParams.toString()}`)
        } else {
          setGeneratedCoverUrl(res.coverUrl)
          setActiveTab("cover")
        }
      })
      .catch((err) => {
        setGenerating(false)
        if (!err) err = "生成失败"
        message.error(err.data || err.message || err)
      })
  }

  // 生成全部
  const handleGenerateAll = () => {
    if (!selectedSoundId || !selectedVideoId) {
      message.warning("请选择音频和视频模型")
      return
    }
    setGenerating(true)
    setModalVisible(false)

    post("/ip/generateall", {
      contentId: noteData.id,
      soundId: selectedSoundId,
      videoId: selectedVideoId,
    })
      .then((res) => {
        setGenerating(false)
        message.success("全部内容生成成功！")

        if (res.pid && res.pid !== noteData.pid) {
          // 保留当前URL参数并添加 contentId
          const currentParams = new URLSearchParams(props.location.search)
          currentParams.set('contentId', res.contentId)
          history.replace(`/index/content/${res.pid}?${currentParams.toString()}`)
          window.location.reload()
        } else if (res.contentId && res.contentId !== noteData.id) {
          // pid 相同但 contentId 不同，需要切换版本
          const currentParams = new URLSearchParams(props.location.search)
          currentParams.set('contentId', res.contentId)
          history.replace(`${props.location.pathname}?${currentParams.toString()}`)
        } else {
          setGeneratedAudioId(res.audioId)
          setGeneratedAudioUrl(res.audioUrl)
          setGeneratedVideo(res.videoUrl)
          setGeneratedCoverUrl(res.coverUrl)
          setActiveTab("cover")
        }
      })
      .catch((err) => {
        setGenerating(false)
        if (!err) err = "生成失败"
        message.error(err.data || err.message || err)
      })
  }

  // 轮询函数
  const startPolling = useCallback(() => {
    // 清除之前的定时器
    if (pollingTimerRef.current) {
      clearInterval(pollingTimerRef.current)
    }

    const timer = setInterval(() => {
      get("/content/viewwithpid", { pid: pid })
        .then((res) => {
          console.log("轮询 /content/viewwithpid res :>> ", res)
          if (res.list && res.list.length > 0) {
            setVersionList(res.list)
            const currentVersion = res.list[currentVersionIndex] || res.list[0]
            setNoteData(currentVersion)
            setImages(currentVersion.images || [])
            if (currentVersion.mp4) {
              setGeneratedVideo(currentVersion.mp4.url)
            }

            // 如果状态不为"2"，停止轮询
            if (currentVersion.status !== 2) {
              setGenerating(false)
              if (pollingTimerRef.current) {
                clearInterval(pollingTimerRef.current)
                pollingTimerRef.current = null
              }
            }
          }
        })
        .catch((err) => {
          console.error("轮询获取数据失败:", err)
          // 出错时也停止轮询
          setGenerating(false)
          if (pollingTimerRef.current) {
            clearInterval(pollingTimerRef.current)
            pollingTimerRef.current = null
          }
        })
    }, 5000)

    pollingTimerRef.current = timer
  }, [pid])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    setLoading(true)
    get("/content/viewwithpid", { pid: pid })
      .then((res) => {
        console.log("/content/viewwithpid res :>> ", res)
        if (res.list && res.list.length > 0) {
          setVersionList(res.list)
          
          // 优先根据 contentId 查找版本
          const contentIdFromUrl = urlSearchParams.get("contentId")
          let defaultIndex = res.list.length - 1 // 默认最后一个（最旧版本）
          
          if (contentIdFromUrl) {
            // 在版本列表中查找匹配的 contentId
            const foundIndex = res.list.findIndex(item => item.id === contentIdFromUrl)
            if (foundIndex !== -1) {
              defaultIndex = foundIndex
            }
          } else {
            // 如果没有 contentId，检查 version 参数
            const versionFromUrl = urlSearchParams.get("version")
            if (versionFromUrl) {
              defaultIndex = parseInt(versionFromUrl)
            }
          }
          
          setCurrentVersionIndex(defaultIndex)
          
          const latestVersion = res.list[defaultIndex] || res.list[0]
          setNoteData(latestVersion)
          setImages(latestVersion.images || [])

          // 处理已生成的资源
          let hasAudio = false
          let hasVideo = false
          let hasCover = false
          
          if (latestVersion.mp4) {
            const mp4 = latestVersion.mp4

            // 处理音频状态
            if (mp4.audio_status === "1" && mp4.sound_url) {
              setGeneratedAudioUrl(mp4.sound_url)
              setGeneratedAudioId(mp4.sound_id)
              hasAudio = true
            } else if (mp4.audio_status === "2") {
              console.log("音频生成中...")
            } else {
              setGeneratedAudioUrl(null)
              setGeneratedAudioId(null)
            }

            // 处理视频状态
            if (mp4.video_status === "1" && mp4.url) {
              setGeneratedVideo(mp4.url)
              hasVideo = true
            } else if (mp4.video_status === "2") {
              console.log("视频生成中...")
            } else {
              setGeneratedVideo(null)
            }

            // 处理封面状态
            if (mp4.cover_status === "1" && mp4.cover_url) {
              setGeneratedCoverUrl(mp4.cover_url)
              hasCover = true
            } else if (mp4.cover_status === "2") {
              console.log("封面生成中...")
            } else {
              setGeneratedCoverUrl(null)
            }
          } else {
            setGeneratedAudioUrl(null)
            setGeneratedAudioId(null)
            setGeneratedVideo(null)
            setGeneratedCoverUrl(null)
          }

          // 智能选择默认tab（仅当地址栏没有tab参数时）
          const tabFromUrl = urlSearchParams.get("tab")
          if (!tabFromUrl) {
            // 按优先级查找有内容的tab：audio -> video -> cover
            if (hasAudio) {
              setActiveTab("audio")
            } else if (hasVideo) {
              setActiveTab("video")
            } else if (hasCover) {
              setActiveTab("cover")
            } else {
              // 都没有内容，默认audio
              setActiveTab("audio")
            }
          }

          // 如果状态为"2"，开启轮询
          if (latestVersion.status === 2) {
            setGenerating(true)
            startPolling()
          }
        }
      })
      .catch((err) => {
        console.error("获取数据失败:", err)
        if (!err) err = "获取数据失败"
        message.error(err.data || err.message || err)
      })
      .finally(() => {
        setLoading(false)
      })
    // 查询用户配额概览
    get("/content/getquotaoverview", {})
      .then((res) => {
        console.log("用户配额概览 - /content/getquotaoverview:", JSON.stringify(res))
      })
      .catch((error) => {
        console.error("获取配额概览失败:", error)
      })
  }, [pid, startPolling])

  useEffect(() => {
    setIsLogin(props.user?.uid)
  }, [props.user])

  // 同步版本到地址栏
  useEffect(() => {
    if (currentVersionIndex >= 0) {
      const currentParams = new URLSearchParams(props.location.search)
      const versionFromUrl = currentParams.get("version")
      if (versionFromUrl !== currentVersionIndex.toString()) {
        currentParams.set("version", currentVersionIndex.toString())
        history.replace(`${props.location.pathname}?${currentParams.toString()}`)
      }
    }
  }, [currentVersionIndex, history, props.location])

  // 同步tab到地址栏
  useEffect(() => {
    const currentParams = new URLSearchParams(props.location.search)
    const tabFromUrl = currentParams.get("tab")
    if (tabFromUrl !== activeTab) {
      currentParams.set("tab", activeTab)
      // 如果地址栏有 contentId，在 tab 切换后删除它
      if (currentParams.has("contentId")) {
        currentParams.delete("contentId")
      }
      history.replace(`${props.location.pathname}?${currentParams.toString()}`)
    }
  }, [activeTab, history, props.location])

  // 监听 contentId 参数变化，切换到对应版本
  useEffect(() => {
    const contentIdFromUrl = urlSearchParams.get("contentId")
    if (contentIdFromUrl && versionList.length > 0) {
      const foundIndex = versionList.findIndex(item => item.id === contentIdFromUrl)
      // 如果地址栏有 contentId，在 tab 切换后删除它
    const currentParams = new URLSearchParams(props.location.search)
      if (currentParams.has("contentId")) {
        currentParams.delete("contentId")
      }
      history.replace(`${props.location.pathname}?${currentParams.toString()}`)
      if (foundIndex !== -1 && foundIndex !== currentVersionIndex) {
        // 找到匹配的版本，切换过去
        setCurrentVersionIndex(foundIndex)
        const selectedVersion = versionList[foundIndex]
        setNoteData(selectedVersion)
        setImages(selectedVersion.images || [])

        // 更新生成的资源
        if (selectedVersion.mp4) {
          const mp4 = selectedVersion.mp4
          if (mp4.audio_status === "1" && mp4.sound_url) {
            setGeneratedAudioUrl(mp4.sound_url)
            setGeneratedAudioId(mp4.sound_id)
          } else {
            setGeneratedAudioUrl(null)
            setGeneratedAudioId(null)
          }

          if (mp4.video_status === "1" && mp4.url) {
            setGeneratedVideo(mp4.url)
          } else {
            setGeneratedVideo(null)
          }

          if (mp4.cover_status === "1" && mp4.cover_url) {
            setGeneratedCoverUrl(mp4.cover_url)
          } else {
            setGeneratedCoverUrl(null)
          }
        } else {
          setGeneratedAudioUrl(null)
          setGeneratedAudioId(null)
          setGeneratedVideo(null)
          setGeneratedCoverUrl(null)
        }
      }
    }
  }, [props.location.search, versionList])

  // 处理从edit页面跳转过来的open_generate参数
  useEffect(() => {
    const openGenerate = urlSearchParams.get("open_generate")
    if (openGenerate && !loading) {
      // 设置对应的tab
      const validTabs = ["audio", "video", "cover", "all"]
      if (validTabs.includes(openGenerate)) {
        setActiveTab(openGenerate as any)

        // 延迟触发，确保数据加载完成
        setTimeout(() => {
          handleGenerate()
        }, 500)

        // 清理URL参数，避免重复触发
        const currentParams = new URLSearchParams(props.location.search)
        currentParams.delete("open_generate")
        history.replace(`${props.location.pathname}?${currentParams.toString()}`)
      }
    }
  }, [])

  // 处理生成按钮点击
  const handleGenerate = async () => {
    // 检查配额
    const canGenerate = await checkVideoQuota()
    if (!canGenerate) {
      return
    }

    switch (activeTab) {
      case "audio":
        // 打开音频选择弹窗
        handleGetSoundList(true)
        setModalVisible(true)
        break
      case "video":
        // 打开视频选择弹窗
        handleGetContentList(true)
        setModalVisible(true)
        break
      case "cover":
        // 直接调用生成封面API
        handleGenerateCover()
        break
      case "all":
        // 打开全部生成弹窗（音频+视频）
        handleGetSoundList(true)
        handleGetContentList(true)
        setModalVisible(true)
        break
    }
  }

  // 清理轮询定时器
  useEffect(() => {
    return () => {
      if (pollingTimerRef.current) {
        clearInterval(pollingTimerRef.current)
      }
    }
  }, [])

  return (
    <GlobalStyle>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner />
        </LoadingOverlay>
      )}
      <div
        style={{
          maxWidth: "1400px",
          position: "relative",
          width: "100%",
          minWidth: "300px",
          margin: "0 auto",
          minHeight: "100vh",
          padding: "0 20px 40px",
          marginTop: "-30px"
        }}
      >
        {/* 主要内容区域 - 使用flex布局 */}
        <div
          style={{
            display: "flex",
            gap: "20px",
            alignItems: "flex-start",
            flexDirection: window.innerWidth > 768 ? "row" : "column",
          }}
        >
          {/* 左侧主内容区域 */}
          <div style={{ flex: 1, minWidth: 0 }}>
            <div
              style={{
                padding: "20px 30px",
                backgroundColor: "#fff",
                borderRadius: "20px",
              }}
            >
              {/* 顶部按钮组 */}
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px", gap: "16px" }}>
                <div
                  style={{
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#666",
                    padding: "8px 16px",
                    borderRadius: "50vmin",
                    border: "1px solid #e0e0e0",
                    transition: "all 0.3s",
                    flexShrink: 0,
                  }}
                  onClick={() => {
                    localStorage.setItem("restore_content_edit_cache", "1")
                    localStorage.setItem("refresh_content_id", noteData.id)
                    localStorage.setItem("refresh_content_pid", noteData.pid || noteData.id)
                    return history.push(`/index/release/createContent`)
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = "var(--theme-main)"
                    e.currentTarget.style.color = "var(--theme-main)"
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = "#e0e0e0"
                    e.currentTarget.style.color = "#666"
                  }}
                >
                  ← 返回
                </div>

                {/* 版本切换按钮组 */}
                {versionList.length > 1 && (
                  <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
                    <Segmented
                      value={currentVersionIndex}
                      onChange={(value) => {
                        const index = value as number
                        setCurrentVersionIndex(index)
                        const selectedVersion = versionList[index]
                        setNoteData(selectedVersion)
                        setImages(selectedVersion.images || [])

                        // 更新生成的资源
                        if (selectedVersion.mp4) {
                          const mp4 = selectedVersion.mp4
                          if (mp4.audio_status === "1" && mp4.sound_url) {
                            setGeneratedAudioUrl(mp4.sound_url)
                            setGeneratedAudioId(mp4.sound_id)
                          } else {
                            setGeneratedAudioUrl(null)
                            setGeneratedAudioId(null)
                          }

                          if (mp4.video_status === "1" && mp4.url) {
                            setGeneratedVideo(mp4.url)
                          } else {
                            setGeneratedVideo(null)
                          }

                          if (mp4.cover_status === "1" && mp4.cover_url) {
                            setGeneratedCoverUrl(mp4.cover_url)
                          } else {
                            setGeneratedCoverUrl(null)
                          }
                        } else {
                          setGeneratedAudioUrl(null)
                          setGeneratedAudioId(null)
                          setGeneratedVideo(null)
                          setGeneratedCoverUrl(null)
                        }
                      }}
                      options={versionList.map((version, index) => ({
                        label: `版本${index + 1}`,
                        value: index,
                      }))}
                      style={{
                        borderRadius: "50vmin",
                        padding: "4px",
                      }}
                      className="version-segmented"
                    />
                  </div>
                )}

                <EditButton
                  onClick={() => {
                    localStorage.setItem("restore_content_edit_cache", "1")
                    localStorage.setItem("refresh_content_id", noteData.id)
                    localStorage.setItem("refresh_content_pid", noteData.pid || noteData.id)
                    props.history.push(`/index/contentedit/${noteData.pid}?version=${currentVersionIndex}&tab=${activeTab}`)
                  }}
                  disabled={generating}
                  className={generating ? "disabled" : ""}
                  style={{ flexShrink: 0 }}
                >
                  编辑笔记
                </EditButton>
              </div>
              {noteData.title ? (
                <Title onDoubleClick={() => !generating && isLogin && props.history.push(`/index/contentedit/${noteData.pid}?auto_focus=title&version=${currentVersionIndex}&tab=${activeTab}`)}>{noteData.title}</Title>
              ) : (
                <Title style={{ color: "#999" }} onDoubleClick={() => !generating && isLogin && props.history.push(`/index/contentedit/${noteData.pid}?auto_focus=title&version=${currentVersionIndex}&tab=${activeTab}`)}>
                  无标题
                </Title>
              )}
              <CreationDate>创建于：{noteData.createtime}</CreationDate>

              <Content onDoubleClick={() => !generating && isLogin && props.history.push(`/index/contentedit/${noteData.pid}?auto_focus=content&version=${currentVersionIndex}&tab=${activeTab}`)}>
                <p>{noteData.content}</p>
              </Content>

              {/* 语音笔记播放器 */}
              {noteData.speech_recognition?.url && (
                <AudioPlayerContainer>
                  <div style={{ width: "100%" }}>
                    <div style={{ fontSize: "12px", color: "#999", marginBottom: "8px" }}>语音笔记</div>
                    <audio controls src={noteData.speech_recognition.url} preload="metadata" style={{ width: "100%" }} />
                    {noteData.speech_recognition.text && <div style={{ marginTop: "12px", fontSize: "14px", color: "#666", lineHeight: "1.6" }}>{noteData.speech_recognition.text}</div>}
                  </div>
                </AudioPlayerContainer>
              )}
            </div>
          </div>

          {/* 右侧面板 */}
          <div
            style={{
              width: window.innerWidth > 768 ? "420px" : "100%",
              flexShrink: 0,
            }}
          >
            <RightPanel
              style={{
                height: "fit-content",
                position: "sticky",
                top: "20px",
              }}
            >
              {/* Tab 切换栏 */}
              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  marginBottom: "20px",
                  borderBottom: "2px solid #f0f0f0",
                  paddingBottom: "8px",
                }}
              >
                <TabButton active={activeTab === "audio"} onClick={() => setActiveTab("audio")}>
                  生成音频
                </TabButton>
                <TabButton active={activeTab === "video"} onClick={() => setActiveTab("video")}>
                  生成视频
                </TabButton>
                <TabButton active={activeTab === "cover"} onClick={() => setActiveTab("cover")}>
                  生成封面
                </TabButton>
                <TabButton active={activeTab === "all"} onClick={() => setActiveTab("all")}>
                  全部生成
                </TabButton>
              </div>

              {/* Tab 内容区域 */}
              <Spin spinning={generating && !generatedAudioUrl && activeTab === "audio"} tip="音频生成中..." size="large">
                <div style={{ minHeight: "260px", marginBottom: "16px" }}>
                  {activeTab === "audio" &&
                    (generatedAudioUrl ? (
                      <div>
                        <div style={{ background: "#f5f5f5", borderRadius: "12px", padding: "20px", marginBottom: "12px" }}>
                          <div style={{ fontSize: "14px", color: "#666", marginBottom: "12px" }}>生成的音频</div>
                          <audio ref={generatedAudioRef} controls style={{ width: "100%" }} src={generatedAudioUrl} />
                        </div>
                        <button
                          onClick={() => window.open(generatedAudioUrl, "_blank")}
                          style={{
                            width: "100%",
                            padding: "10px 20px",
                            backgroundColor: "#fff",
                            color: "var(--theme-main)",
                            border: "1px solid var(--theme-main)",
                            borderRadius: "50vmin",
                            fontSize: "14px",
                            fontWeight: "500",
                            cursor: "pointer",
                            transition: "all 0.3s",
                          }}
                          onMouseEnter={(e) => {
                            const target = e.target as HTMLButtonElement
                            target.style.backgroundColor = "var(--theme-main)"
                            target.style.color = "#fff"
                          }}
                          onMouseLeave={(e) => {
                            const target = e.target as HTMLButtonElement
                            target.style.backgroundColor = "#fff"
                            target.style.color = "var(--theme-main)"
                          }}
                        >
                          下载音频
                        </button>
                      </div>
                    ) : (
                      <div style={{ textAlign: "center", padding: "40px 20px" }}>
                        <div style={{ width: 80, height: 80, background: "#f2f6fa", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48.000000" height="48.000000" fill="none">
                            <defs>
                              <image id="image_0" width="200.000000" height="200.000000" xlinkHref={require("../../../images/mp4Default.png")} />
                              <pattern id="pattern_0" width="1.000000" height="1.000000" image-fill-type="fill" patternContentUnits="objectBoundingBox">
                                <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_0" />
                              </pattern>
                            </defs>
                            <rect id="ico-navigation-voiceover 1" width="200.000000" height="200.000000" x="0.000000" y="0.000000" fill="url(#pattern_0)" />
                          </svg>
                        </div>
                        <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8, color: "#666" }}>生成AI音频</div>
                        <div style={{ fontSize: 14, color: "#999" }}>将文字转换为自然流畅的语音</div>
                      </div>
                    ))}

                  {activeTab === "video" &&
                    (generating ? (
                      <GlobalLoadingOverlay>
                        <LoadingContent>
                          <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                            <LoadingSpinner />
                          </div>
                          <LoadingText>AI视频生成中...</LoadingText>
                          <LoadingSubText>
                            正在为您生成高质量的AI视频内容
                            <br />
                            预计需要3-5分钟，请耐心等待
                          </LoadingSubText>
                        </LoadingContent>
                      </GlobalLoadingOverlay>
                    ) : generatedVideo ? (
                      <div>
                        <video
                          controls
                          ref={videoRef}
                          onLoadedMetadata={() => {
                            if (videoRef.current) {
                              videoRef.current.playbackRate = playbackRate
                            }
                          }}
                          style={{
                            width: "100%",
                            height: "180px",
                            objectFit: "cover",
                            borderRadius: "12px",
                            background: "#000",
                          }}
                        >
                          <source src={generatedVideo} />
                          您的浏览器不支持视频播放
                        </video>
                        <div style={{ display: "flex", alignItems: "center", marginTop: "8px", marginBottom: "4px" }}>
                          <span style={{ marginRight: "8px", fontSize: "14px", color: "#666" }}>播放速度：</span>
                          <Select
                            value={playbackRate}
                            onChange={(value) => {
                              setPlaybackRate(value)
                              if (videoRef.current) {
                                videoRef.current.playbackRate = value
                              }
                            }}
                            style={{ width: 120 }}
                            size="small"
                          >
                            <Select.Option value={0.5}>0.5x</Select.Option>
                            <Select.Option value={0.75}>0.75x</Select.Option>
                            <Select.Option value={1}>1x</Select.Option>
                            <Select.Option value={1.25}>1.25x</Select.Option>
                            <Select.Option value={1.5}>1.5x</Select.Option>
                            <Select.Option value={1.75}>1.75x</Select.Option>
                            <Select.Option value={2}>2x</Select.Option>
                          </Select>
                        </div>
                        <button
                          onClick={() => {
                            window.open(generatedVideo, "_blank")
                          }}
                          style={{
                            width: "100%",
                            marginTop: "12px",
                            padding: "10px 20px",
                            backgroundColor: "#fff",
                            color: "var(--theme-main)",
                            border: "1px solid var(--theme-main)",
                            borderRadius: "50vmin",
                            fontSize: "14px",
                            fontWeight: "500",
                            cursor: "pointer",
                            transition: "all 0.3s",
                          }}
                          onMouseEnter={(e) => {
                            const target = e.target as HTMLButtonElement
                            target.style.backgroundColor = "var(--theme-main)"
                            target.style.color = "#fff"
                          }}
                          onMouseLeave={(e) => {
                            const target = e.target as HTMLButtonElement
                            target.style.backgroundColor = "#fff"
                            target.style.color = "var(--theme-main)"
                          }}
                        >
                          下载视频
                        </button>
                      </div>
                    ) : (
                      <div style={{ textAlign: "center", padding: "40px 20px" }}>
                        <div
                          style={{
                            width: 80,
                            height: 80,
                            background: "#f2f6fa",
                            borderRadius: "16px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 16px",
                          }}
                        >
                          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48.000000" height="48.000000" fill="none">
                            <defs>
                              <image id="image_0" width="200.000000" height="200.000000" xlinkHref={require("../../../images/mp4Default.png")} />
                              <pattern id="pattern_0" width="1.000000" height="1.000000" image-fill-type="fill" patternContentUnits="objectBoundingBox">
                                <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_0" />
                              </pattern>
                            </defs>
                            <rect id="ico-navigation-voiceover 1" width="200.000000" height="200.000000" x="0.000000" y="0.000000" fill="url(#pattern_0)" />
                          </svg>
                        </div>
                        <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8, color: "#666" }}>生成AI视频</div>
                        <div style={{ fontSize: 14, color: "#999" }}>将文字转换为精美的视频内容</div>
                      </div>
                    ))}

                  {activeTab === "cover" &&
                    (generating ? (
                      <GlobalLoadingOverlay>
                        <LoadingContent>
                          <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                            <LoadingSpinner />
                          </div>
                          <LoadingText>AI封面生成中...</LoadingText>
                          <LoadingSubText>
                            正在为您生成精美的封面图片
                            <br />
                            预计需要1-2分钟，请耐心等待
                          </LoadingSubText>
                        </LoadingContent>
                      </GlobalLoadingOverlay>
                    ) : generatedCoverUrl ? (
                      <div>
                        <div style={{ background: "#f5f5f5", borderRadius: "12px", padding: "20px", marginBottom: "12px" }}>
                          <img src={generatedCoverUrl} alt="封面" style={{ width: "100%", borderRadius: "8px" }} />
                        </div>
                        <button
                          onClick={() => window.open(generatedCoverUrl, "_blank")}
                          style={{
                            width: "100%",
                            padding: "10px 20px",
                            backgroundColor: "#fff",
                            color: "var(--theme-main)",
                            border: "1px solid var(--theme-main)",
                            borderRadius: "50vmin",
                            fontSize: "14px",
                            fontWeight: "500",
                            cursor: "pointer",
                            transition: "all 0.3s",
                          }}
                          onMouseEnter={(e) => {
                            const target = e.target as HTMLButtonElement
                            target.style.backgroundColor = "var(--theme-main)"
                            target.style.color = "#fff"
                          }}
                          onMouseLeave={(e) => {
                            const target = e.target as HTMLButtonElement
                            target.style.backgroundColor = "#fff"
                            target.style.color = "var(--theme-main)"
                          }}
                        >
                          下载封面
                        </button>
                      </div>
                    ) : (
                      <div style={{ textAlign: "center", padding: "40px 20px" }}>
                        <div style={{ width: 80, height: 80, background: "#f2f6fa", borderRadius: "16px", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px" }}>
                          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="48.000000" height="48.000000" fill="none">
                            <defs>
                              <image id="image_0" width="200.000000" height="200.000000" xlinkHref={require("../../../images/mp4Default.png")} />
                              <pattern id="pattern_0" width="1.000000" height="1.000000" image-fill-type="fill" patternContentUnits="objectBoundingBox">
                                <use transform="matrix(0.005,0,0,0.005,0,0)" xlinkHref="#image_0" />
                              </pattern>
                            </defs>
                            <rect id="ico-navigation-voiceover 1" width="200.000000" height="200.000000" x="0.000000" y="0.000000" fill="url(#pattern_0)" />
                          </svg>
                        </div>
                        <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8, color: "#666" }}>生成封面</div>
                        <div style={{ fontSize: 14, color: "#999" }}>为内容创建吸引眼球的封面图</div>
                      </div>
                    ))}

                  {activeTab === "all" &&
                    (generating ? (
                      <GlobalLoadingOverlay>
                        <LoadingContent>
                          <div style={{ display: "flex", justifyContent: "center", marginBottom: "20px" }}>
                            <LoadingSpinner />
                          </div>
                          <LoadingText>全部内容生成中...</LoadingText>
                          <LoadingSubText>
                            正在为您生成音频、视频和封面
                            <br />
                            预计需要5-8分钟，请耐心等待
                          </LoadingSubText>
                        </LoadingContent>
                      </GlobalLoadingOverlay>
                    ) : (
                      <div style={{ textAlign: "center", padding: "40px 20px" }}>
                        <div style={{ fontSize: 16, fontWeight: 500, marginBottom: 8, color: "#666" }}>一键生成全部</div>
                        <div style={{ fontSize: 14, color: "#999" }}>同时生成音频、视频和封面</div>
                      </div>
                    ))}
                </div>
              </Spin>

              {/* 底部生成按钮 */}
              <GenerateButton onClick={handleGenerate} disabled={generating}>
                {activeTab === "audio" && "开始生成音频"}
                {activeTab === "video" && "开始生成视频"}
                {activeTab === "cover" && "开始生成封面"}
                {activeTab === "all" && "开始生成全部"}
              </GenerateButton>
            </RightPanel>
          </div>
        </div>

        {/* 弹窗 */}
        <Modal
          title={activeTab === "audio" ? "选择音频模型" : activeTab === "video" ? "选择视频模型" : "选择模型"}
          open={modalVisible}
          onCancel={() => setModalVisible(false)}
          footer={null}
          width={800}
        >
          {/* 只在需要音频时显示 */}
          {(activeTab === "audio" || activeTab === "all") && (
            <ModalSection>
              <h4>声音模型</h4>
              {soundLoading ? (
                <div style={{ height: 120, display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <Spin />
                </div>
              ) : (
                <SoundList
                  onWheel={(e) => {
                    e.preventDefault()
                    const scrollContainer = e.currentTarget
                    scrollContainer.scrollLeft += e.deltaY
                  }}
                >
                  {soundList.map((item) => (
                    <SoundItem key={item.id} className={selectedSoundId === item.id ? "selected" : ""} onClick={() => setSelectedSoundId(item.id)}>
                      <SoundInfo>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                          <div style={{ flex: 1, width: "93px" }}>
                            <SoundTitle>{item.filename || "音频文件"}</SoundTitle>
                            <SoundTime>{item.updatetime}</SoundTime>
                          </div>
                          <ActionButton
                            onClick={(e) => {
                              e.stopPropagation()
                              if (audioRef.current) {
                                if (isPlaying && audioRef.current.src === item.url) {
                                  audioRef.current.pause()
                                  setIsPlaying(false)
                                } else {
                                  audioRef.current.src = item.url
                                  audioRef.current.play()
                                  setIsPlaying(true)
                                }
                              }
                            }}
                            style={{
                              padding: "4px 8px",
                              fontSize: "12px",
                              opacity: item.url ? 1 : 0.5,
                              cursor: item.url ? "pointer" : "not-allowed",
                            }}
                            disabled={!item.url}
                          >
                            {isPlaying && audioRef.current?.src === item.url ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
                          </ActionButton>
                        </div>
                      </SoundInfo>
                    </SoundItem>
                  ))}
                  {soundList.length < soundLength && (
                    <SoundLoadMoreButton onClick={() => handleGetSoundList()}>
                      <RightOutlined className="load-more-icon" />
                    </SoundLoadMoreButton>
                  )}
                </SoundList>
              )}
              <audio ref={audioRef} onEnded={() => setIsPlaying(false)} onError={() => setIsPlaying(false)} />
            </ModalSection>
          )}

          {/* 只在需要视频时显示 */}
          {(activeTab === "video" || activeTab === "all") && (
            <ModalSection>
              <h4>视频模型</h4>
              {innerLoading ? (
                <Spin style={{ height: 270 }} />
              ) : (
                <VideoList
                  onWheel={(e) => {
                    e.preventDefault()
                    const scrollContainer = e.currentTarget
                    scrollContainer.scrollLeft += e.deltaY
                  }}
                >
                  {contentList.map((item) => (
                    <VideoItem key={item.id} className={selectedVideoId === item.id ? "selected" : ""} onClick={() => setSelectedVideoId(item.id)}>
                      <VideoPlayer controls>
                        <source src={item.url} />
                        您的浏览器不支持视频播放
                      </VideoPlayer>
                      <VideoInfo>
                        <div style={{ float: "left" }}>
                          <VideoTitle>{item.filename}</VideoTitle>
                          <VideoTime>{item.updatetime}</VideoTime>
                        </div>
                      </VideoInfo>
                    </VideoItem>
                  ))}
                  {contentList.length < viewLength && (
                    <LoadMoreButton onClick={() => handleGetContentList()}>
                      <RightOutlined className="load-more-icon" />
                    </LoadMoreButton>
                  )}
                </VideoList>
              )}
            </ModalSection>
          )}

          <div style={{ textAlign: "center", marginTop: "20px" }}>
            {activeTab === "audio" && (
              <ActionButton
                onClick={handleGenerateAudio}
                disabled={!selectedSoundId || generating}
                style={{
                  opacity: !selectedSoundId || generating ? 0.5 : 1,
                  cursor: !selectedSoundId || generating ? "not-allowed" : "pointer",
                }}
              >
                {generating ? "生成中..." : "生成音频"}
              </ActionButton>
            )}
            {activeTab === "video" && (
              <ActionButton
                onClick={handleGenerateVideo}
                disabled={!selectedVideoId || !generatedAudioUrl || generating}
                style={{
                  opacity: !selectedVideoId || !generatedAudioUrl || generating ? 0.5 : 1,
                  cursor: !selectedVideoId || !generatedAudioUrl || generating ? "not-allowed" : "pointer",
                }}
              >
                {generating ? "生成中..." : "生成视频"}
              </ActionButton>
            )}
            {activeTab === "all" && (
              <ActionButton
                onClick={handleGenerateAll}
                disabled={!selectedVideoId || !selectedSoundId || generating}
                style={{
                  opacity: !selectedVideoId || !selectedSoundId || generating ? 0.5 : 1,
                  cursor: !selectedVideoId || !selectedSoundId || generating ? "not-allowed" : "pointer",
                }}
              >
                {generating ? "生成中..." : "全部生成"}
              </ActionButton>
            )}
          </div>
        </Modal>
      </div>
    </GlobalStyle>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setLoginBindInfo: (data) => {
      dispatch(setLoginBindInfo(data))
    },
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    finishCheckLogin: state.finishCheckLogin,
    user: state.login_user_data,
    loginBindInfo: state.loginBindInfo,
  }
}

export default BanUnLogin(Main(connect(mapStateToProps, mapDispatchToProps)(Note)))
